import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { DataSecurityWithAllFeaturesAndRanksTct } from '@dealstack/shared/lib/generated';
import { zodResolver } from '@hookform/resolvers/zod';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';
import {
	RedemptionRightsType,
	SecurityRedemptionRightsFormDto,
	SecurityRedemptionRightsShape,
} from './redemptionRights.zod.ts';

export enum REDEMPTION_RIGHTS_FORM_FIELD {
	type = 'type',
	term = 'term',
	termDuration = 'termDuration',
}

export const useRedemptionRightsController = (
	security: DataSecurityWithAllFeaturesAndRanksTct | null,
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>
) => {
	const defaultValues = useMemo(
		() => ({
			id: security?.securityRedemptionRights?.id,
			type: security?.securityRedemptionRights?.term
				? RedemptionRightsType.FIXED
				: RedemptionRightsType.PERPETUAL,
			term: security?.securityRedemptionRights?.term,
			termDuration: security?.securityRedemptionRights?.termDuration ?? undefined,
		}),
		[security]
	);

	const redemptionRightsForm = useForm<SecurityRedemptionRightsFormDto>({
		mode: 'all',
		resolver: zodResolver(SecurityRedemptionRightsShape(tCapManage)),
		defaultValues,
		shouldFocusError: false,
	});
	const redemptionType = redemptionRightsForm.watch(REDEMPTION_RIGHTS_FORM_FIELD.type);

	const validateTermField = (type: string) => {
		if (redemptionRightsForm && type === RedemptionRightsType.PERPETUAL) {
			redemptionRightsForm.setValue(REDEMPTION_RIGHTS_FORM_FIELD.term, null);
			redemptionRightsForm.setValue(REDEMPTION_RIGHTS_FORM_FIELD.termDuration, '');
			redemptionRightsForm.clearErrors();
		}
	};

	const resetForm = () => {
		redemptionRightsForm.reset(defaultValues);
	};

	return {
		redemptionRightsForm,
		resetForm,
		validateTermField,
		isTermDisabled: redemptionType === RedemptionRightsType.PERPETUAL,
	};
};
